/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { REQUEST_STATUS } from "@/ts/enums/RequestStatus";
import { getStudentCertificateThunk } from "../thunks/certificateThunks";

interface CertificateState {
    status: REQUEST_STATUS;
    error: string | null;
    data: any | null;
}

const initialState: CertificateState = {
    status: REQUEST_STATUS.IDLE,
    error: null,
    data: null,
};

const certificateSlice = createSlice({
    name: "reporting/certificate",
    initialState,
    reducers: {
        resetCertificateState: () => initialState,
        clearCertificate: state => {
            state.status = REQUEST_STATUS.IDLE;
            state.error = null;
            state.data = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getStudentCertificateThunk.pending, state => {
                state.status = REQUEST_STATUS.PENDING;
                state.error = null;
            })
            .addCase(
                getStudentCertificateThunk.fulfilled,
                (state, action: PayloadAction<any>) => {
                    state.status = REQUEST_STATUS.SUCCESS;
                    state.data = action.payload;
                }
            )
            .addCase(getStudentCertificateThunk.rejected, (state, action) => {
                state.status = REQUEST_STATUS.ERROR;
                state.error =
                    (action.payload as string) ?? action.error.message ?? "Unknown error";
                state.data = null;
            });
    },
});

export const { resetCertificateState, clearCertificate } = certificateSlice.actions;
export default certificateSlice.reducer;
